import { render } from "./ConflictSolution.vue?vue&type=template&id=83620f02&scoped=true"
import script from "./ConflictSolution.vue?vue&type=script&lang=js"
export * from "./ConflictSolution.vue?vue&type=script&lang=js"

import "./ConflictSolution.vue?vue&type=style&index=0&id=83620f02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83620f02"]])

export default __exports__